import "./ProfileSetupScreen.css";
import { useEffect, useState } from "react";
import letsDoItIcon from "../../assets/images/lets-do-it-icon.svg";
import bannerIcon from "../../assets/images/profile-setup-banner-icon.svg";
import bannerBcIcon from "../../assets/images/profile-setup-background-image.svg";
import tickIcon from "../../assets/images/profile-setup-tick.svg";
import selectedTickIcon from "../../assets/images/profile-setup-selected-tick.svg";
import { useMutation } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useStorage } from "services/StorageProvider";
import { WEB_LINK } from "utils/strings";
import { trackSignUp } from "utils/analytics";

const ProfileSetupScreen = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const { updateUserProfile } = useWSMApi();
  const { userProfileData, updateUserProfileData } = useStorage();
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
  const isValidPhoneNumber = (number: string) => {
    const phoneNumber = parsePhoneNumberFromString("+" + number);
    return phoneNumber ? phoneNumber.isValid() : false;
  };
  const isDisabled =
    !firstName.trim() ||
    !lastName.trim() ||
    !mobileNumber.trim() ||
    !isValidPhoneNumber(mobileNumber) ||
    !termsAccepted;

  useEffect(() => {
    setFirstName(userProfileData?.first_name || "");
    setLastName(userProfileData?.last_name || "");
    setMobileNumber(userProfileData?.mobile_number?.replace("+", "") || "");
  }, [userProfileData]);

  const updateUserMutation = useMutation({
    mutationFn: () =>
      updateUserProfile({
        first_name: firstName,
        last_name: lastName,
        mobile_number: "+" + mobileNumber,
      }),
    onSuccess: (response) => {
      updateUserProfileData(response);
      trackSignUp();
      navigate(ROUTE_PATHS.WSM_HOME, { replace: true });
    },
  });

  const handleContinueClick = () => {
    updateUserMutation.mutate();
  };

  return (
    <div className="wms-mobile-container">
      <div className="profile-setup-screen-container">
        <header className="profile-setup-screen-header-header-bar">
          ENTER THE ECOSYSTEM
        </header>
        <div className="profile-setup-screen-top-container">
          <img
            src={bannerBcIcon}
            alt="profile-setup-banner"
            className="background-image "
          />
        </div>
        <div className="profile-setup-screen-banner-container">
          <div className="first-text">
            This is a{" "}
            <span style={{ color: "#C2B58C" }}>progressive ECOSYSTEM</span>
          </div>
          <div className="second-text">
            built for{" "}
            <span style={{ color: "#C2B58C" }}>
              Founders & Remote Workers who value Focus, Clarity, and
              Sustainable Growth.
            </span>
          </div>
          <div className="divider"></div>
          <div className="banner-container">
            <img src={bannerIcon} alt="banner-logo" />
            <>Before you step in — we’d like to know who’s joining us.</>
          </div>
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            First <span className="sub-text">Name</span>
          </span>
          <input
            placeholder="Enter First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            Last <span className="sub-text">Name</span>
          </span>
          <input
            placeholder="Enter Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            Phone <span className="sub-text">Number</span>
          </span>
          <PhoneInput
            country={"in"}
            value={mobileNumber}
            onChange={setMobileNumber}
            countryCodeEditable={false}
            inputProps={{
              name: "mobile",
              required: true,
              autoFocus: true,
            }}
            containerClass="profile-setup-custom-phone"
            inputClass="profile-setup-custom-phone-input"
          />
        </div>

        <div
          className="profile-setup-screen-footer-container"
          onClick={() => setTermsAccepted(!termsAccepted)}
        >
          <img
            src={termsAccepted ? selectedTickIcon : tickIcon}
            alt="info-logo"
          />
          <span>
            By continuing, you agree to the{" "}
            <span
              className="terms-link"
              onClick={(e) => {
                e.stopPropagation();
                navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
                  state: {
                    anyData: {
                      title: "Terms & Conditions",
                      url: WEB_LINK.TERM_CONDITION,
                    },
                  },
                });
              }}
            >
              Terms & Conditions
            </span>
            .
          </span>
        </div>
        <button
          onClick={handleContinueClick}
          disabled={isDisabled || updateUserMutation.isPending}
        >
          {updateUserMutation?.isPending ? (
            <CircularProgress size={30} color="inherit" />
          ) : (
            <>
              Enter SabeHub
              <img src={letsDoItIcon} alt="lets-do-it-logo" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ProfileSetupScreen;
